import {BaseModel} from '../../../shared';

export class Persona extends BaseModel{
  personaId: string;
  personaCedula: string;
  personaNombre: string;
  personaPrimerApellido: string;
  personaSegundoApellido: string;
  personaFechaDeNacimiento: string;
  personaTelefono: string;
  personaEmail: string;

  name(): string {
    return `${this.personaPrimerApellido} ${this.personaNombre}`;
  }
}

